import React from 'react';
import { NavBar } from '../../../Modules/Navigation/components/NavBar/NavBar';
import PageContentCardContainer from '../../../ui/Layout/PageContentCardContainer/PageContentCardContainer';
import TiktokSongSuggestions from '../../../Modules/TikTok/audios/features/TiktokSongSuggestions/TiktokSongSuggestions';
import styles from './TiktokSongSuggestionsPage.module.css';

const TiktokSongSuggestionsPage = () => (
    <>
        <NavBar />
        <PageContentCardContainer>
            <h1 className={styles.title}>Songs</h1>
            <TiktokSongSuggestions />
        </PageContentCardContainer>
    </>
);

export default TiktokSongSuggestionsPage;
